<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="bulkEnglishTestForm" (change)="bulkEnglishTestFormChange()"
        (submit)="bulkEnglishTestFormSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">
                    {{"BULK_ENGLISH_TEST" | translate | titlecase }}
                </h6>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <!-- <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "BULK_SHEET" | translate | titlecase }}.</label>
                                <input type="file" class="form-control" formControlName="bulkSheet"
                                    (change)="changeFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="bulkEnglishTestForm.controls.bulkSheet.touched && bulkEnglishTestForm.controls.bulkSheet.invalid && bulkEnglishTestForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-md-12 form-group px-md-5 mb-4" style="text-align: center;">
                                <button type="submit" class="btn btn-primary m-2 rounded-0" style="margin: 0 auto;"><i
                                        class="fas fa"></i>
                                    {{"SHOW_BULK_RESULT" | translate | titlecase}}</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 d-flex flex-wrap justify-content-center justify-content-lg-end">
                                <p [innerHTML]="displayData"
                                    style="margin: 0 auto;text-align: center;color: green;font-weight: bold; font-size: 15px;">
                                </p>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-8 d-flex flex-wrap justify-content-center justify-content-lg-end">
                                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/home"
                                    *ngIf="!creating">
                                    {{"CANCEL" | translate | titlecase}}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                                        class="fas fa"></i>
                                    {{"SAVE" | translate | titlecase}}</button>
                                <app-loader [show]="creating"></app-loader>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<app-loader [attr.show]="showLoader"></app-loader>